<template>
  <div class="sp_step">
    <p style="padding:10px; background: #EDF4FF; border-radius: 4px; border: 1px solid #A3CFFF; margin-bottom:10px;">{{$t('loginModule.forgotPassHint')}}</p>
    <el-form :model="stepTwoForm"
             @submit.native.prevent
             ref="stepTwoForm"
             :rules="stepTwoRules">
      <el-form-item :label="$t('loginModule.verificationCode')+'：'"
                    prop="verificationCode">
        <el-input type="text"
                  size="medium"
                  v-model.trim="stepTwoForm.verificationCode"></el-input>
      </el-form-item>
      <el-form-item>
        <p>
          {{$t("loginModule.noCode")}}&nbsp;
          <el-button type="text"
                     :disabled="timeOut>0"
                     @click="sendCode">{{$t("loginModule.sendAgain")}}</el-button>
          <span style="display:inline-block; width:24px; text-align:center;">&nbsp;{{timeOut}}s</span>
        </p>
        <el-button :loading="checkLoad"
                   type="primary"
                   style="width:100%;height:48px; font-size:16px;"
                   @click="nextStep('stepTwoForm')"
                   size="medium">{{$t('loginModule.next')}}</el-button>
        <div class="sp_login_skip">
          <router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { checkForgetEmail, sendForgetPwdEmail } from '@/api/loginApi.js'
import { registerEncrypt } from '@/utils/encrypt.js'
export default {
  name: 'stepTwo',
  props: {
    forgotParamstwo: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      stepTwoForm: {
        verificationCode: '',
      },

      stepTwoRules: {
        verificationCode: [
          {
            required: true,
            message: 'Please input the verification code.',
            trigger: 'blur',
          },
        ],
      },

      timeOut: 59,
      checkLoad: false,
    }
  },

  methods: {
    //点击下一步
    nextStep(stepTwoForm) {
      this.$refs[stepTwoForm].validate((valid) => {
        if (valid) {
          this.checkLoad = true
          let params = {
            code: JSON.parse(JSON.stringify(this.stepTwoForm.verificationCode)),
            email: registerEncrypt(
              JSON.parse(JSON.stringify(this.forgotParamstwo.email))
            ),
          }
          checkForgetEmail(params)
            .then((res) => {
              console.log(res);
              this.checkLoad = false
              this.$emit('stepTwo', {
                code: this.stepTwoForm.verificationCode,
                checkSuccess: true,
                // verificationCode: res.verificationCode
              })
            })
            .catch(() => {
              this.checkLoad = false
            })
        }
      })
    },

    //倒计时
    countDown() {
      const timeNum = 59
      let timer = setInterval(() => {
        if (this.timeOut > 0 && this.timeOut <= timeNum) {
          this.timeOut--
          this.$ls.set('timeOut', this.timeOut)
        } else {
          clearInterval(timer)
          this.timer = null
        }
      }, 1000)
    },

    //发送验证码
    sendCode() {
      let params = JSON.parse(JSON.stringify(this.forgotParamstwo.email))
      params = registerEncrypt(params)
      sendForgetPwdEmail(params)
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Send successfully',
          })
          this.timeOut = 59
          this.countDown()
        })
        .catch(() => {
          this.timeOut = 0
        })
    },
  },

  activated() {
    let timeNum = this.$ls.get('timeOut')
    if (timeNum) {
      this.timeOut = timeNum
    }
    this.countDown()
    this.stepTwoForm.verificationCode = this.forgotParamstwo.code
  },
}
</script>

<style>
</style>